import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal-900 py-8 px-6 border-t border-charcoal-800 text-center" data-id="element-10">
      <div className="container mx-auto" data-id="element-11">
        <img src="https://cdn.magicpatterns.com/uploads/f6oGZNXWeK5xhE3LRPxK4U/1000121817.png" alt="MA Barber Studio" className="w-20 h-20 object-cover rounded-full mx-auto mb-4 border-0" style={{
        clipPath: 'circle(48% at center)'
      }} data-id="element-12" />
        <p className="text-cream-muted text-xs font-light" data-id="element-13">
          &copy; {new Date().getFullYear()} MA Barber Studio. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}